import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class Map extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div>
        <div style={{backgroundColor: 'red',width:'100%'}}>
			<a href='https://www.google.com/maps/place/Roomy+Sapanca+Tiny+House/@40.6926074,30.2801103,15z/data=!4m2!3m1!1s0x0:0xe401c75072bcf937?sa=X&ved=2ahUKEwi69MO2pLqBAxV9SPEDHY7eDlMQ_BJ6BAhHEAA&ved=2ahUKEwi69MO2pLqBAxV9SPEDHY7eDlMQ_BJ6BAhQEAg'>   </a>
            </div>
		</div>
        }
}

export default Map
